/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_On_Open_TabInputs */

const en_wc_on_open_tab = /** @type {(inputs: Wc_On_Open_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open editor in a new tab`)
};

/**
* | output |
* | --- |
* | "Open editor in a new tab" |
*
* @param {Wc_On_Open_TabInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_on_open_tab = /** @type {((inputs?: Wc_On_Open_TabInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_On_Open_TabInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_on_open_tab(inputs)
});
export { wc_on_open_tab as "wc.on.open_tab" }